import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error Boundary Caught an Error:', error, errorInfo);
  }

  componentDidUpdate(prevProps) {
    const prevResetKeys = prevProps.resetKeys || [];
    const nextResetKeys = this.props.resetKeys || [];
    const keysChanged =
      prevResetKeys.length !== nextResetKeys.length ||
      prevResetKeys.some((item, idx) => item !== nextResetKeys[idx]);

    if (this.state.hasError && keysChanged) {
      this.resetErrorBoundary();
    }
  }

  resetErrorBoundary() {
    this.setState({ hasError: false, error: null });
  }

  render() {
    if (this.state.hasError) {
      if (typeof this.props.fallbackRender === 'function') {
        return this.props.fallbackRender({
          error: this.state.error,
          resetErrorBoundary: this.resetErrorBoundary,
        });
      }

      return (
        <div style={{ padding: 24, textAlign: 'center' }}>
          <h2>Something went wrong.</h2>
          <p style={{ opacity: 0.8 }}>
            This view failed to load. You can retry without reloading the whole page.
          </p>
          <button
            type="button"
            onClick={this.resetErrorBoundary}
            style={{
              border: 0,
              borderRadius: 6,
              padding: '8px 14px',
              cursor: 'pointer',
              background: '#0ea5e9',
              color: '#fff',
            }}
          >
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
